export default function WhyUsRow({ icon, title, description }) {
  return (
    <div className="flex flex-col gap-5 border-t border-neutral-200 py-6 sm:grid sm:grid-cols-12 sm:gap-6 sm:py-8">
      <div className="flex items-center gap-4 sm:col-span-6">
        <img
          src={icon}
          alt=""
          aria-hidden="true"
          className="h-12 w-12 shrink-0 select-none sm:h-14 sm:w-14"
          draggable="false"
        />
        <h3 className="text-base font-medium text-neutral-900 sm:text-[15px]">{title}</h3>
      </div>
      <p className="text-sm leading-relaxed text-neutral-500 sm:col-span-6">{description}</p>
    </div>
  );
}
